import PropTypes from "prop-types"
import React from "react"

import HorizontalRule from "./HorizontalRule"
import LineItem from "./LineItem"

const PLACEHOLDER_SIZES = new Map([
  ["price", "h-7"],
  ["discounted_price", "h-7"],
  ["total", "h-6"],
  ["section_heading", "my-2.5 h-[15.4px]"],
])

const placeholderRows = ({ lineItems, loadingTypes, loadingItems }) => {
  if (lineItems.length > 0) return lineItems
  if (loadingTypes.length > 0) return loadingTypes.map((type) => ({ type }))

  return Array.from({ length: loadingItems }, () => ({}))
}

const placeholderSize = ({ type, source }) => {
  if (type === "discount" && source === "dockwa_plus") return "h-7"

  return PLACEHOLDER_SIZES.get(type) || "h-5"
}

const Placeholder = ({ type, source }) => {
  if (type === "horizontal_rule") return <HorizontalRule />

  const size = placeholderSize({ type, source })

  return (
    <div className={`flex ${size} items-center justify-between`}>
      <div className="h-4 w-20 rounded-full bg-gray-200 dark:bg-gray-700" />
      <div className="h-4 w-14 rounded-full bg-gray-200 dark:bg-gray-700" />
    </div>
  )
}

Placeholder.propTypes = {
  type: PropTypes.string,
  source: PropTypes.string,
}

const LineItems = ({
  lineItems = [],
  loading = false,
  loadingTypes = [],
  loadingItems = 4,
  currency = "USD",
  spacing = 2,
}) => {
  return loading ? (
    <div className={`my-2 flex animate-pulse flex-col gap-${spacing}`}>
      {placeholderRows({ lineItems, loadingTypes, loadingItems }).map(
        ({ type, source }, index) => (
          <Placeholder key={index} type={type} source={source} />
        )
      )}
    </div>
  ) : (
    <div className={`my-2 flex flex-col gap-${spacing}`}>
      {lineItems.map((lineItem, index) => (
        <LineItem
          key={`${lineItem.type}:${index}`}
          loading={loading}
          currency={currency}
          {...lineItem}
        />
      ))}
    </div>
  )
}

LineItems.propTypes = {
  lineItems: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      label: PropTypes.string,
      amount: PropTypes.number,
      suffix: PropTypes.string,
      source: PropTypes.string,
    })
  ),
  loading: PropTypes.bool,
  loadingTypes: PropTypes.arrayOf(PropTypes.string),
  loadingItems: PropTypes.number,
  currency: PropTypes.string,
  spacing: PropTypes.number,
}

export default LineItems
